import React from 'react';
import {
  Activity,
  ActivityBottom,
  ActivityBox,
  Address,
  Amount,
  AmountRate,
  Box,
  Desc,
  Description,
  Details,
  First,
  From,
  GroupHeader,
  Heading,
  InfoRate,
  InputDesc,
  InputId,
  InputTitle,
  InvoiceLeft,
  InvoiceRight,
  InvoiceTable,
  Label,
  LeftContent,
  LeftRow,
  Line,
  MainContent,
  MainDiv,
  Note,
  NoteDescription,
  NoteTitle,
  Price,
  Quantity,
  QuantityRate,
  RightBottom,
  Rightbox,
  RightContent,
  RightHeader,
  RightRow,
  Row,
  Title,
  Title2,
  TopBottom,
  TopInvoice,
  Topleft,
  Total,
  TotalContent
} from './styles';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import Image from '../../image';

const InvoiceDetailsLoading: React.FC = () => {
  //MobX state variables
  const { appStore } = rootStore;
  const { themeMode } = appStore || {};
  return (
    <MainContent>
      <LeftContent>
        <MainDiv isDark={themeMode.theme}>
          <div className='before' />
          <TopInvoice>
            <InvoiceLeft>
              <Image imageKey='invoicing_empty_profile' alt='empty-profile' width={40} height={40} />
              <Details>
                <InputId>
                  <InputTitle className='loading-animation' />
                  <InputDesc className='loading-animation' />
                </InputId>
                <InputId>
                  <InputTitle className='loading-animation' />
                  <InputDesc className='loading-animation' />
                </InputId>
                <InputId>
                  <InputTitle className='loading-animation' />
                  <InputDesc className='last loading-animation' />
                </InputId>
              </Details>
            </InvoiceLeft>
            <InvoiceRight>
              <Title2>INVOICE</Title2>
              <Address>
                <Box>
                  <From className='loading-animation' />
                  <Rightbox>
                    <Title className='title loading-animation' />
                    <RightBottom>
                      <First className='loading-animation' />
                      <First className='second loading-animation' />
                      <First className='third loading-animation' />
                    </RightBottom>
                  </Rightbox>
                </Box>
                <Box>
                  <From className='loading-animation' />
                  <Rightbox>
                    <Title className='title loading-animation' />
                    <RightBottom>
                      <First className='loading-animation' />
                      <First className='second loading-animation' />
                      <First className='third loading-animation' />
                    </RightBottom>
                  </Rightbox>
                </Box>
              </Address>
            </InvoiceRight>
          </TopInvoice>
          <InvoiceTable>
            <GroupHeader>
              <Label>Description</Label>
              <RightHeader>
                <Quantity>Qty</Quantity>
                <Price>Unit Price</Price>
                <Amount>Amount</Amount>
              </RightHeader>
            </GroupHeader>
            <Row>
              <LeftRow>
                <Topleft className='loading-animation' />
                <TopBottom className='loading-animation' />
              </LeftRow>
              <RightRow>
                <QuantityRate className='loading-animation' />
                <InfoRate className='loading-animation' />
                <AmountRate className='loading-animation' />
              </RightRow>
            </Row>
            <Row>
              <LeftRow>
                <Topleft className='loading-animation' />
                <TopBottom className='loading-animation' />
              </LeftRow>
              <RightRow>
                <QuantityRate className='loading-animation' />
                <InfoRate className='loading-animation' />
                <AmountRate className='loading-animation' />
              </RightRow>
            </Row>
            <Row>
              <LeftRow>
                <Topleft className='loading-animation' />
                <TopBottom className='loading-animation' />
              </LeftRow>
              <RightRow>
                <QuantityRate className='loading-animation' />
                <InfoRate className='loading-animation' />
                <AmountRate className='loading-animation' />
              </RightRow>
            </Row>
            <Total>
              <Line>
                <Heading className='first loading-animation' />
                <Description className='loading-animation' />
              </Line>
              <Line>
                <Heading className='second loading-animation' />
                <Description className='loading-animation' />
              </Line>
              <Line>
                <Heading className='loading-animation' />
                <Description className='loading-animation' />
              </Line>
              <Line>
                <Heading className='loading-animation' />
                <Description className='loading-animation' />
              </Line>
            </Total>
            <Note>
              <NoteTitle className='loading-animation' />
              <NoteDescription className='loading-animation' />
            </Note>
          </InvoiceTable>
          <div className='after' />
        </MainDiv>
      </LeftContent>
      <RightContent>
        <ActivityBox>
          <Activity>
            <TotalContent>Activity</TotalContent>
            <ActivityBottom>
              <Title className='loading-animation' />
              <Desc className='loading-animation' />
            </ActivityBottom>
            <ActivityBottom>
              <Title className='loading-animation' />
              <Desc className='loading-animation' />
            </ActivityBottom>
            <ActivityBottom>
              <Title className='loading-animation' />
              <Desc className='loading-animation' />
            </ActivityBottom>
            <ActivityBottom className='last'>
              <Title className='loading-animation' />
              <Desc className='loading-animation' />
            </ActivityBottom>
          </Activity>
        </ActivityBox>
      </RightContent>
    </MainContent>
  );
};

export default observer(InvoiceDetailsLoading);
